module.exports = __webpack_public_path__ + "img/products-briefcase.cf3040d0.svg";